<script>
  import { textfit } from "svelte-textfit"

  export let minFontSize = 6
  export let maxFontSize = 800
  export let containerHeight
  export let containerWidth
  export let update
</script>

<div
  use:textfit={{
    width: containerWidth,
    height: containerHeight,
    min: minFontSize,
    max: maxFontSize,
    update: update,
  }}
>
  <slot />
</div>
